// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__7yZD5","next":"Pagination_next__ucCjH","prev":"Pagination_prev__ruwNA","number":"Pagination_number__NrVux"};